module.exports = __webpack_public_path__ + "img/BN1.cef70089.svg";